module.exports = __webpack_public_path__ + "img/home5.50831d02.svg";